var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#010101",
  clipPath: "url(#istock-images-icon)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.942 0H2.75A2.753 2.753 0 0 0 0 2.75v11.193a2.753 2.753 0 0 0 2.75 2.75h11.192a2.753 2.753 0 0 0 2.75-2.75V2.75A2.753 2.753 0 0 0 13.942 0M2.75 1.5h11.192c.69 0 1.25.56 1.25 1.25v6.606L12.387 6.55a1.5 1.5 0 0 0-2.122 0l-4.318 4.317-1.481-1.482c-.58-.58-1.5-.593-2.095-.027l-.871.829V2.75c0-.69.56-1.25 1.25-1.25m11.192 13.693H2.75c-.69 0-1.25-.56-1.25-1.25v-1.687l1.904-1.81 1.483 1.482c.566.566 1.554.566 2.12 0l4.32-4.317 3.865 3.866v2.466c0 .69-.56 1.25-1.25 1.25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.538 7.196a1.761 1.761 0 1 0 0-3.523 1.761 1.761 0 0 0 0 3.523"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "istock-images-icon"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16.692v16.692H0z"
})))));
export default SvgImages;